function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import { updateTaskAssigneeAndResponsibleCompany, updateTasksAssigneeAndResponsibleCompany } from 'utils/strategic-partner-utils';
const transformFieldAccessToBase3 = (task)=>task.fieldsAccessMeta != null ? {
        ...task,
        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
    } : task;
const transformFieldAccessToBase3ForTasks = (tasks)=>tasks.map(transformFieldAccessToBase3);
const transformResponse = (response)=>{
    return Array.isArray(response) ? updateTasksAssigneeAndResponsibleCompany(transformFieldAccessToBase3ForTasks(response)) : updateTaskAssigneeAndResponsibleCompany(transformFieldAccessToBase3(response));
};
export class WithNotStrategicTransformer extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getWithTransformer", (url, config)=>{
            return this.get(url, {
                ...config !== null && config !== void 0 ? config : {}
            }).then((response)=>transformResponse(response));
        }), _define_property(this, "putWithTransformer", (url, payload, config)=>{
            return this.put(url, payload, {
                ...config !== null && config !== void 0 ? config : {},
                params: {
                }
            }).then((response)=>transformResponse(response));
        }), _define_property(this, "postWithTransformer", (url, payload, config)=>{
            return this.post(url, payload, {
                ...config !== null && config !== void 0 ? config : {},
                params: {
                }
            }).then((response)=>transformResponse(response));
        });
    }
}
